<template>
	<div class="home">
        <el-select style="width:960px;margin-bottom:20px" v-model="categoryId" placeholder="请选择版块">
			<el-option
				v-for="(item, i) in sectionList"
				:key="i"
				:label="replace(item.name)"
				:value="item.id">
			</el-option>
        </el-select>
		<el-input
			placeholder="请输入您的问题标题"
			v-model="input"
			clearable
			:disabled="num == 1"
			style="width:960px;margin-bottom:20px"
			ref="position"
		></el-input>

		<div id="globalEditorBox" style="width:960px"></div>
		<div class="file">
			<el-upload class="upload-demo" drag :action="fileUrl" multiple :on-success="upSuccess"  :on-remove="handleRemove" :before-upload="beforeAvatarUpload">
				<!-- <i class="el-icon-upload"></i> -->
				<!-- <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div> -->
				<p>上传附件(仅支持PDF格式文件)</p>
			</el-upload>
		</div>
	</div>
</template>

<script>
import {
	Message
} from 'element-ui'
// 引入 wangEditor
const root = process.env.H5_API_ROOT;
import wangEditor from "wangeditor";
export default {
	data() {
		return {
			fileUrl:root +'upload/singleFile',
			globalEditor: null,
			input:'',
			editorData: "",
			fileList:[],
			file:'',

			sectionList: [],
			categoryId: '',
		};
	},
	props: {
			'type' : String,
			'title' : String,
			'num':Number
	},
	watch:{
		num(){
			this.initData()
		}
	},
	mounted() {
		this.getSection()
		this.$nextTick(() =>{
			this.$refs.position.focus()
		})
		this.initData()

		const globalEditor = new wangEditor(`#globalEditorBox`);

		globalEditor.config.showFullScreen = false //关闭全屏
		globalEditor.config.showLinkImg = false //隐藏插入网络图片
		globalEditor.config.showLinkVideo = false//隐藏插入网络视频
		globalEditor.config.uploadImgMaxSize = 10 * 1024 * 1024 // 图片大小2M
		globalEditor.config.uploadVideoMaxSize = 100 * 1024 * 1024  // 视频大小100M

		globalEditor.config.menus = [
			// 'head',
			// 'bold',
			// 'fontSize',
			// 'fontName',
			// 'italic',
			// 'underline',
			// 'strikeThrough',
			// 'indent',
			// 'lineHeight',
			// 'foreColor',
			// 'backColor',
			// 'link',
			// 'list',
			// 'todo',
			// 'justify',
			// 'quote',
			// 'emoticon',
			'image',
			'video',
			// 'table',
			// 'code',
			// 'splitLine',
			// 'undo',
			// 'redo',
		]


		globalEditor.config.uploadImgServer = root + "upload/singleFile";
		globalEditor.config.uploadFileName = "file";

		globalEditor.config.uploadVideoServer = root + "upload/singleFile";
		globalEditor.config.uploadVideoName = 'file'

		globalEditor.config.uploadImgHooks = {
			// 图片上传并返回了结果，图片插入已成功
			success: function(xhr) {
				console.log("success", xhr);
			},
			// 图片上传并返回了结果，但图片插入时出错了
			fail: function(xhr, editor, resData) {
				console.log("fail", resData);
			},
			// 上传图片出错，一般为 http 请求的错误
			error: function(xhr, editor, resData) {
				console.log("error", xhr, resData);
			},
			// 上传图片超时
			timeout: function(xhr) {
				console.log("timeout");
			},
			// 图片上传并返回了结果，想要自己把图片插入到编辑器中
			// 例如服务器端返回的不是 { errno: 0, data: [...] } 这种格式，可使用 customInsert
			customInsert: function(insertImgFn, result) {
				// result 即服务端返回的接口
				console.log("customInsert", result);

				// insertImgFn 可把图片插入到编辑器，传入图片 src ，执行函数即可
				insertImgFn( result.data)
			}
		};

		globalEditor.config.uploadVideoHooks = {
			// 上传视频之前
			// before: function(xhr) {
			// 	console.log(xhr)

			// 	// 可阻止视频上传
			// 	// return {
			// 	//     prevent: true,
			// 	//     msg: '需要提示给用户的错误信息'
			// 	// }
			// },
			// 视频上传并返回了结果，视频插入已成功
			success: function(xhr) {
				console.log('success', xhr)
			},
			// 视频上传并返回了结果，但视频插入时出错了
			fail: function(xhr, editor, resData) {
				console.log('fail', resData)
			},
			// 上传视频出错，一般为 http 请求的错误
			error: function(xhr, editor, resData) {
				console.log('error', xhr, resData)
			},
			// 上传视频超时
			timeout: function(xhr) {
				console.log('timeout')
			},
			// 视频上传并返回了结果，想要自己把视频插入到编辑器中
			// 例如服务器端返回的不是 { errno: 0, data: { url : '.....'} } 这种格式，可使用 customInsert
			customInsert: function(insertVideoFn, result) {
				// result 即服务端返回的接口
				console.log('customInsert', result)

				// insertVideoFn 可把视频插入到编辑器，传入视频 src ，执行函数即可
				insertVideoFn(result.data)
			}
		}



		// 配置 onchange 回调函数，将数据同步到 vue 中
		globalEditor.config.onchange = newHtml => {
			this.editorData = newHtml;
		};
		if(this.num == 1){
			globalEditor.config.placeholder = '请输入您的回答'
		}else{
			globalEditor.config.placeholder = '您可以在这里进一步描述您的问题'
		}


		// 创建编辑器
		globalEditor.create();
		this.globalEditor = globalEditor;
	},
	methods: {
		replace(text){
			var reg = new RegExp("<br/>","g");
			var x = text.replace(reg,"");
			return x
		},
		getSection(){
			this.h5Ajax("get", "$/category/listFlatCatgories", {
					page: 1,
					pid: 0,
					size: 100,
					types: 1,
			}, true)
				.then(res => {
					console.log(res, "头部提问");
					this.sectionList = res
				})
		},
		clearData(){
			if(this.num != 1){
				this.input = '',
				this.categoryId = ''
			}
			this.globalEditor.txt.clear()
		},
		beforeAvatarUpload(file) {
			console.log(file)
			const isJPG = file.type === 'application/pdf';
			const isLt2M = file.size / 1024 / 1024 < 50;

			if (!isJPG) {
			this.$message.error('请上传PDF格式的附件!');
			}
			if (!isLt2M) {
			this.$message.error('上传附件大小不能超过 50MB!');
			}
			return isJPG && isLt2M;
		},
		upSuccess(file, fileList){
			console.log(file);
			console.log(fileList);
			if(file.code == 200){
				this.fileList.push(fileList.response.data)
				this.file = this.fileList.join(',')
				console.log(this.file)
			}else{
				this.$message({
					showClose: true,
					message: file.message,
					type: 'warning'
				})
			}

		},
		handleRemove(file, fileList){
			console.log(file)
			console.log(fileList)
			// this.fileList.push(fileList.response.data)
			// this.file = this.fileList.join(',')
			let x = fileList.map(x =>{
				return x.response.data
			})
			this.file = x.join(',')
			console.log(this.file)
		},


		initData(){
			this.input = this.title || ''
			console.log(this.num)
			if(this.num == 2){
				this.input = ''
			}
		},
		submitModelRelease() {
			if(this.categoryId == '' || this.categoryId == null || this.categoryId == undefined){
				this.$message({
					showClose: true,
					message: '请先选择板块',
					type: 'warning'
				})
				return
			}
			if(this.input == ''){
				this.$message({
					showClose: true,
					message: '请输入标题',
					type: 'warning'
				})
				return
			}
			if(this.globalEditor.txt.html() == ''){
				this.$message({
					showClose: true,
					message: '请输入详情描述',
					type: 'warning'
				})
				return
			}
			// 通过代码获取编辑器内容
			let content = this.globalEditor.txt.html();
			let title = this.input
			let file = this.file
			let categoryId = this.categoryId
			return{content,title,file, categoryId}
		},

	},
	beforeDestroy() {
		// 调用销毁 API 对当前编辑器实例进行销毁
		this.globalEditor.destroy();
		this.globalEditor = null;
	}
};
</script>

<style lang="scss" scoped>

.home {
	/deep/ .w-e-text{
		a{text-decoration: underline!important;color:#2440B3!important}
	}
	width: 1000px;
	margin: auto;
	position: relative;

	.title {
		font-size: 20px;
		color: #000;
		padding: 20px;
	}
	.btn {
		position: absolute;
		right: 0;
		top: 0;
		padding: 5px 10px;
		cursor: pointer;
	}
	h3 {
		margin: 30px 0 15px;
	}
	/deep/ .el-upload-list__item{
		width: 963px;
	}
	/deep/ .el-upload-list__item .el-icon-upload-success{
		color: rgb(213, 0, 28);
	}
	/deep/ .el-upload-list{
		margin-bottom: 20px;
	}
	/deep/ .el-upload-dragger{
		    height: 24px;
			position: absolute;
			top: 129px;
			width: 180px;
			left: 100px;
			z-index: 999999;
			font-size: 12px;
			background: #D5001C;
			color: #fff;
			border: 1px solid red;
			line-height: 2;
			border-radius: 0;
	}
	/deep/ .el-icon-upload{
		margin: 20px auto 16px;
	}
	/deep/ .w-e-icon-image{
		line-height: 1.6;
	}
}
</style>



// WEBPACK FOOTER //
// src/pc/components/release/globalAsk.vue